import "bootstrap/dist/css/bootstrap.min.css";
import { get, ref } from "firebase/database";
import { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { db } from "../Firebase";

const AHeader = () => {
  const [stats, setStats] = useState({ pending: 0, total: 0, thisMonth: 0, rejected: 0 });
  const [isScrolled, setIsScrolled] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [showProfile, setShowProfile] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [showPreferences, setShowPreferences] = useState(false);
  const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);
  const [allStats, setAllStats] = useState({
    totalMembers: 0, totalFamilies: 0, totalStates: 0, totalCities: 0,
    totalBlocks: 0, totalMandirs: 0, approvedFamilies: 0, pendingFamilies: 0,
    rejectedFamilies: 0, thisMonthRegistrations: 0
  });
  const navigate = useNavigate();

  const userData = {
    name: "Admin User",
    email: "admin@jainsamagraportal.com",
    role: "Super Admin",
    avatar: "👤"
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    
    window.addEventListener('scroll', handleScroll);
    fetchStats();
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const fetchStats = async () => {
    try {
      const snap = await get(ref(db, 'registration'));
      const counts = { pending: 0, total: 0, thisMonth: 0, rejected: 0 };
      const allCounts = {
        totalMembers: 0, totalFamilies: 0, totalStates: 0, totalCities: 0,
        totalBlocks: 0, totalMandirs: 0, approvedFamilies: 0, pendingFamilies: 0,
        rejectedFamilies: 0, thisMonthRegistrations: 0
      };

      if (snap.exists()) {
        const currentMonth = new Date().getMonth();
        const currentYear = new Date().getFullYear();
        const statesSet = new Set(), citiesSet = new Set(), blocksSet = new Set(), mandirsSet = new Set();

        Object.values(snap.val()).forEach((r) => {
          counts.total++;
          allCounts.totalFamilies++;
          if (r.members) allCounts.totalMembers += Object.keys(r.members).length;
          if (r.basic?.state) statesSet.add(r.basic.state);
          if (r.basic?.city) citiesSet.add(r.basic.city);
          if (r.basic?.block) blocksSet.add(r.basic.block);
          if (r.basic?.Mandirtype) mandirsSet.add(r.basic.Mandirtype);
          if (r.meta?.createdAt) {
            const regDate = new Date(r.meta.createdAt);
            if (regDate.getMonth() === currentMonth && regDate.getFullYear() === currentYear) {
              counts.thisMonth++;
              allCounts.thisMonthRegistrations++;
            }
          }
          const status = r.meta?.status || 'pending';
          if (status === 'pending') { counts.pending++; allCounts.pendingFamilies++; }
          else if (status === 'rejected') { counts.rejected++; allCounts.rejectedFamilies++; }
          else if (status === 'approved') allCounts.approvedFamilies++;
        });

        allCounts.totalStates = statesSet.size;
        allCounts.totalCities = citiesSet.size;
        allCounts.totalBlocks = blocksSet.size;
        allCounts.totalMandirs = mandirsSet.size;
      }

      setStats(counts);
      setAllStats(allCounts);
    } catch (e) {
      console.error('Stats fetch error:', e);
    }
  };

  const toggleDropdown = (dropdownName) => {
    setOpenDropdown(openDropdown === dropdownName ? null : dropdownName);
  };

  const handleLogout = () => {
    if (window.confirm('क्या आप वाकई लॉगआउट करना चाहते हैं?')) {
      localStorage.removeItem('loggedUser');
      navigate('/Select-login');
    }
  };

  return (
    <>
      <nav
        className={`navbar navbar-expand-lg shadow-lg fixed-top ${isScrolled ? 'navbar-scrolled' : ''}`}
        style={{
          background: isScrolled 
            ? "linear-gradient(135deg, rgba(13, 148, 136, 0.95) 0%, rgba(11, 122, 111, 0.95) 100%)"
            : "linear-gradient(135deg, #0D9488 0%, #0B7A6F 100%)",
          zIndex: 1030,
          height: isScrolled ? "70px" : "80px",
          transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
          backdropFilter: isScrolled ? "blur(20px)" : "none",
          borderBottom: "3px solid rgba(13, 148, 136, 0.3)"
        }}
      >
        <div className="container-fluid px-4">
          {/* Brand Section */}
          <div className="d-flex align-items-center">
            <div className="logo-container me-3" style={{
              transition: "transform 0.3s ease",
              cursor: "pointer"
            }}
            onMouseEnter={(e) => e.target.style.transform = "scale(1.1) rotate(5deg)"}
            onMouseLeave={(e) => e.target.style.transform = "scale(1) rotate(0deg)"}>
              <img 
                src="/Logo.png" 
                alt="Logo" 
                height={isScrolled ? "45" : "55"}
                style={{ 
                  transition: "all 0.3s ease",
                  filter: "drop-shadow(0 4px 8px rgba(0,0,0,0.3))"
                }}
              />
            </div>
            
            <Link
              className="navbar-brand fw-bold d-flex align-items-center"
              to="/Amain"
              style={{ 
                color: "#fff", 
                textShadow: "2px 2px 8px rgba(0,0,0,0.4)",
                textDecoration: "none",
                fontSize: isScrolled ? "1.4rem" : "1.6rem",
                transition: "all 0.3s ease"
              }}
            >
              <span className="me-2" style={{ fontSize: "1.2em" }}>🏛️</span>
              <span className="brand-text">Admin Dashboard</span>
            </Link>
          </div>

          {/* Mobile Toggle */}
          <button
            className="navbar-toggler border-0 shadow-none"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#adminNavbar"
            aria-controls="adminNavbar"
            aria-expanded="false"
            aria-label="Toggle navigation"
            style={{
              background: "rgba(255,255,255,0.15)",
              borderRadius: "12px",
              padding: "10px 14px"
            }}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Navigation */}
          <div className="collapse navbar-collapse" id="adminNavbar">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0 gap-1">
              {/* Dashboard */}
              <li className="nav-item">
                <NavLink 
                  className="nav-link fw-semibold px-3 py-2 rounded-pill nav-link-enhanced" 
                  to="/Amain"
                  style={({ isActive }) => ({
                    color: isActive ? "#ffd700" : "#e5e7eb",
                    background: isActive ? "rgba(255,215,0,0.15)" : "transparent",
                    transition: "all 0.3s ease"
                  })}
                >
                  <span className="me-1">🏠</span> Dashboard
                </NavLink>
              </li>

              {/* Advanced Analytics */}
              <li className="nav-item">
                <NavLink 
                  className="nav-link fw-semibold px-3 py-2 rounded-pill nav-link-enhanced" 
                  to="/advanced-analytics"
                  style={({ isActive }) => ({
                    color: isActive ? "#ffd700" : "#e5e7eb",
                    background: isActive ? "rgba(255,215,0,0.15)" : "transparent",
                    transition: "all 0.3s ease"
                  })}
                >
                  <span className="me-1">📊</span> Analytics
                </NavLink>
              </li>

              {/* Filters */}
              <li className="nav-item">
                <button
                  className="nav-link fw-semibold px-3 py-2 rounded-pill text-light btn btn-link border-0 nav-link-enhanced"
                  onClick={() => setShowFilters(true)}
                >
                  <span className="me-1">🔎</span> Filters
                </button>
              </li>

              {/* Advanced Search */}
              <li className="nav-item">
                <button
                  className="nav-link fw-semibold px-3 py-2 rounded-pill text-light btn btn-link border-0 nav-link-enhanced"
                  onClick={() => setShowAdvancedSearch(true)}
                >
                  <span className="me-1">🔍</span> Advanced Search
                </button>
              </li>

              {/* Registrations Dropdown */}
              <li className="nav-item dropdown position-relative">
                <button
                  className="nav-link fw-semibold px-3 py-2 rounded-pill text-light btn btn-link border-0 nav-link-enhanced"
                  onClick={() => toggleDropdown('registrations')}
                >
                  <span className="me-1">📋</span> Registrations
                </button>
                {openDropdown === 'registrations' && (
                  <ul className="dropdown-menu show shadow-lg border-0 dropdown-enhanced">
                    <li><NavLink className="dropdown-item" to="/pending-approvals" onClick={() => setOpenDropdown(null)}>
                      ⏳ Pending Approvals
                    </NavLink></li>
                    <li><NavLink className="dropdown-item" to="/Registrationdata" onClick={() => setOpenDropdown(null)}>
                      🔍 Search Registration
                    </NavLink></li>
                    <li><hr className="dropdown-divider" /></li>
                    <li><NavLink className="dropdown-item" to="/approved-registrations" onClick={() => setOpenDropdown(null)}>
                      ✅ Approved
                    </NavLink></li>
                    <li><NavLink className="dropdown-item" to="/requests" onClick={() => setOpenDropdown(null)}>
                      ⚠ Request Changes
                    </NavLink></li>
                    <li><NavLink className="dropdown-item" to="/rejected-registrations" onClick={() => setOpenDropdown(null)}>
                      ❌ Rejected
                    </NavLink></li>
                    <li><hr className="dropdown-divider" /></li>
                    <li><NavLink className="dropdown-item" to="/vishisht-admin" onClick={() => setOpenDropdown(null)}>
                      🏅 विशिष्ठ पंजीयन
                    </NavLink></li>
                  </ul>
                )}
              </li>

              {/* Masters Dropdown */}
              <li className="nav-item dropdown position-relative">
                <button
                  className="nav-link fw-semibold px-3 py-2 rounded-pill text-light btn btn-link border-0 nav-link-enhanced"
                  onClick={() => toggleDropdown('masters')}
                >
                  <span className="me-1">⚙️</span> Masters
                </button>
                {openDropdown === 'masters' && (
                  <ul className="dropdown-menu show shadow-lg border-0 dropdown-enhanced">
                    <li><NavLink className="dropdown-item" to="/Location" onClick={() => setOpenDropdown(null)}>
                      📍 Location Master
                    </NavLink></li>
                    <li><NavLink className="dropdown-item" to="/othermasters" onClick={() => setOpenDropdown(null)}>
                      🛕 Jain Mandir Master
                    </NavLink></li>
                    <li><NavLink className="dropdown-item" to="/jati-prakar" onClick={() => setOpenDropdown(null)}>
                      🏛️ Jati Prakar
                    </NavLink></li>
                    <li><NavLink className="dropdown-item" to="/work-master" onClick={() => setOpenDropdown(null)}>
                      💼 Work Master
                    </NavLink></li>
                  </ul>
                )}
              </li>

              {/* Management Dropdown */}
              <li className="nav-item dropdown position-relative">
                <button
                  className="nav-link fw-semibold px-3 py-2 rounded-pill text-light btn btn-link border-0 nav-link-enhanced"
                  onClick={() => toggleDropdown('management')}
                >
                  <span className="me-1">🎛️</span> Management
                </button>
                {openDropdown === 'management' && (
                  <ul className="dropdown-menu show shadow-lg border-0 dropdown-enhanced">
                    <li><NavLink className="dropdown-item" to="/edit-approval" onClick={() => setOpenDropdown(null)}>
                      ✏️ Edit Approval
                    </NavLink></li>
                    <li><NavLink className="dropdown-item" to="/edit-news" onClick={() => setOpenDropdown(null)}>
                      📰 Edit News
                    </NavLink></li>
                    <li><NavLink className="dropdown-item" to="/team-admin" onClick={() => setOpenDropdown(null)}>
                      👥 Team Admin
                    </NavLink></li>
                    <li><NavLink className="dropdown-item" to="/Adminpass" onClick={() => setOpenDropdown(null)}>
                      👥 Admin Users
                    </NavLink></li>
                  </ul>
                )}
              </li>

              {/* Notifications */}
              <li className="nav-item dropdown position-relative">
                <button
                  className="nav-link fw-semibold px-3 py-2 rounded-pill text-light btn btn-link border-0 nav-link-enhanced"
                  onClick={() => setShowNotifications(!showNotifications)}
                >
                  <span className="me-1">🔔</span>
                  <span className="badge bg-danger notification-badge">3</span>
                </button>
                {showNotifications && (
                  <div className="dropdown-menu show shadow-lg border-0 dropdown-enhanced notification-dropdown">
                    <h6 className="dropdown-header">Recent Notifications</h6>
                    <div className="notification-item">
                      <div className="d-flex align-items-center p-2">
                        <div className="notification-icon bg-success">✅</div>
                        <div className="ms-2">
                          <small className="fw-bold">New Registration Approved</small>
                          <div className="text-muted" style={{fontSize: "0.75rem"}}>2 minutes ago</div>
                        </div>
                      </div>
                    </div>
                    <div className="notification-item">
                      <div className="d-flex align-items-center p-2">
                        <div className="notification-icon bg-warning">⏳</div>
                        <div className="ms-2">
                          <small className="fw-bold">Pending Approval Required</small>
                          <div className="text-muted" style={{fontSize: "0.75rem"}}>5 minutes ago</div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </li>

              {/* Profile Dropdown */}
              <li className="nav-item dropdown position-relative">
                <button
                  className="nav-link fw-semibold px-3 py-2 rounded-pill text-light btn btn-link border-0 d-flex align-items-center nav-link-enhanced"
                  onClick={() => setShowProfile(!showProfile)}
                >
                  <div className="avatar-container me-2">
                    <span className="avatar">{userData.avatar}</span>
                  </div>
                  <span className="d-none d-lg-inline">{userData.name}</span>
                </button>
                {showProfile && (
                  <ul className="dropdown-menu dropdown-menu-end show shadow-lg border-0 dropdown-enhanced profile-dropdown">
                    <li className="dropdown-header">
                      <div className="text-center">
                        <div className="avatar-large mb-2">{userData.avatar}</div>
                        <div className="fw-bold">{userData.name}</div>
                        <small className="text-muted">{userData.role}</small>
                      </div>
                    </li>
                    <li><hr className="dropdown-divider" /></li>
                    <li><button className="dropdown-item" onClick={() => { setShowProfile(false); setTimeout(() => setShowProfile(true), 0); }}>
                      👤 Profile Settings
                    </button></li>
                    <li><button className="dropdown-item" onClick={() => { setShowProfile(false); setShowPreferences(true); }}>
                      🔧 Preferences
                    </button></li>
                    <li><hr className="dropdown-divider" /></li>
                    <li><button className="dropdown-item text-danger" onClick={handleLogout}>
                      🚪 Logout
                    </button></li>
                  </ul>
                )}
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Stats Bar */}
      <div
        className="stats-bar"
        style={{
          background: "linear-gradient(90deg, #f8f9ff 0%, #e8ecff 50%, #f8f9ff 100%)",
          color: "#0D9488",
          fontWeight: "600",
          height: "50px",
          lineHeight: "50px",
          borderTop: "3px solid #0D9488",
          borderBottom: "3px solid #94A3B8",
          marginTop: isScrolled ? "70px" : "80px",
          transition: "margin-top 0.4s ease",
          boxShadow: "0 4px 15px rgba(13, 148, 136, 0.15)",
          position: "relative",
          overflow: "hidden"
        }}
      >
        <div className="container-fluid px-4">
          <div className="row align-items-center">
            <div className="col-md-8">
              <div className="d-flex align-items-center gap-4">
                <div className="stat-item">
                  <span className="me-1">📊</span>
                  <strong>Total: {stats.total}</strong>
                </div>
                <div className="stat-item">
                  <span className="me-1">⏳</span>
                  <strong>Pending: {stats.pending}</strong>
                </div>
                <div className="stat-item">
                  <span className="me-1">📅</span>
                  <strong>This Month: {stats.thisMonth}</strong>
                </div>
              </div>
            </div>
            <div className="col-md-4 text-end">
              <small className="text-muted">
                Last updated: {new Date().toLocaleTimeString()}
              </small>
            </div>
          </div>
        </div>
      </div>

      {/* Filters Modal */}
      {showFilters && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}>
          <div className="modal-dialog modal-xl">
            <div className="modal-content border-0 shadow-lg">
              <div className="modal-header" style={{ background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)' }}>
                <h5 className="modal-title text-white fw-bold">📊 Data Filters & Statistics</h5>
                <button type="button" className="btn-close btn-close-white" onClick={() => setShowFilters(false)}></button>
              </div>
              <div className="modal-body p-4">
                <div className="row g-4">
                  <div className="col-12">
                    <h6 className="text-primary fw-bold mb-3">📈 Overall Statistics</h6>
                    <div className="row g-3">
                      {[
                        { label: 'Total Members', value: allStats.totalMembers, color: '#3b82f6', icon: 'fa-users' },
                        { label: 'Total Families', value: allStats.totalFamilies, color: '#10b981', icon: 'fa-home' },
                        { label: 'States', value: allStats.totalStates, color: '#f59e0b', icon: 'fa-map-marker-alt' },
                        { label: 'Cities', value: allStats.totalCities, color: '#8b5cf6', icon: 'fa-city' },
                        { label: 'Blocks', value: allStats.totalBlocks, color: '#06b6d4', icon: 'fa-building' },
                        { label: 'Jain Mandirs', value: allStats.totalMandirs, color: '#ef4444', icon: 'fa-place-of-worship' },
                        { label: 'Approved Families', value: allStats.approvedFamilies, color: '#059669', icon: 'fa-check-circle' },
                        { label: 'Pending Families', value: allStats.pendingFamilies, color: '#f97316', icon: 'fa-clock' },
                        { label: 'This Month', value: allStats.thisMonthRegistrations, color: '#84cc16', icon: 'fa-calendar-alt' },
                      ].map(({ label, value, color, icon }) => (
                        <div className="col-lg-3 col-md-6" key={label}>
                          <div className="card border-0 h-100 text-center" style={{ borderLeft: `4px solid ${color}`, background: '#fff' }}>
                            <div className="card-body">
                              <i className={`fas ${icon} fa-2x mb-2`} style={{ color }}></i>
                              <h4 className="fw-bold" style={{ color }}>{value}</h4>
                              <p className="mb-0 text-secondary">{label}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="col-12">
                    <h6 className="text-primary fw-bold mb-3">🔍 Quick Filters</h6>
                    <div className="row g-3">
                      <div className="col-md-4">
                        <div className="card border-0 bg-light"><div className="card-body">
                          <h6 className="text-dark mb-3">📋 By Status</h6>
                          <div className="d-grid gap-2">
                            <button className="btn btn-outline-success btn-sm" onClick={() => { navigate('/approved-registrations'); setShowFilters(false); }}>✅ Approved ({allStats.approvedFamilies})</button>
                            <button className="btn btn-outline-warning btn-sm" onClick={() => { navigate('/pending-approvals'); setShowFilters(false); }}>⏳ Pending ({allStats.pendingFamilies})</button>
                            <button className="btn btn-outline-danger btn-sm" onClick={() => { navigate('/rejected-registrations'); setShowFilters(false); }}>❌ Rejected ({allStats.rejectedFamilies})</button>
                          </div>
                        </div></div>
                      </div>
                      <div className="col-md-4">
                        <div className="card border-0 bg-light"><div className="card-body">
                          <h6 className="text-dark mb-3">📅 By Time Period</h6>
                          <div className="d-grid gap-2">
                            <button className="btn btn-outline-primary btn-sm" onClick={() => { navigate('/Registrationdata?filter=today'); setShowFilters(false); }}>📅 Today</button>
                            <button className="btn btn-outline-primary btn-sm" onClick={() => { navigate('/Registrationdata?filter=thisweek'); setShowFilters(false); }}>📅 This Week</button>
                            <button className="btn btn-outline-primary btn-sm" onClick={() => { navigate('/Registrationdata?filter=thismonth'); setShowFilters(false); }}>📅 This Month ({allStats.thisMonthRegistrations})</button>
                          </div>
                        </div></div>
                      </div>
                      <div className="col-md-4">
                        <div className="card border-0 bg-light"><div className="card-body">
                          <h6 className="text-dark mb-3">📊 By Data Type</h6>
                          <div className="d-grid gap-2">
                            <button className="btn btn-outline-info btn-sm" onClick={() => { navigate('/Registrationdata'); setShowFilters(false); }}>👥 All Registrations</button>
                            <button className="btn btn-outline-info btn-sm" onClick={() => { navigate('/Location'); setShowFilters(false); }}>📍 Locations</button>
                            <button className="btn btn-outline-info btn-sm" onClick={() => { navigate('/othermasters'); setShowFilters(false); }}>⚙️ Master Data</button>
                          </div>
                        </div></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer border-0">
                <button type="button" className="btn btn-secondary" onClick={() => setShowFilters(false)}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Advanced Search Modal */}
      {showAdvancedSearch && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}>
          <div className="modal-dialog modal-xl">
            <div className="modal-content border-0 shadow-lg">
              <div className="modal-header" style={{ background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)' }}>
                <h5 className="modal-title text-white fw-bold">🔍 Advanced Search</h5>
                <button type="button" className="btn-close btn-close-white" onClick={() => setShowAdvancedSearch(false)}></button>
              </div>
              <div className="modal-body p-4">
                <div className="row g-4">
                  <div className="col-lg-8">
                    <div className="card border-0 bg-light h-100"><div className="card-body">
                      <h6 className="text-primary fw-bold mb-4">🔍 Search Parameters</h6>
                      <div className="mb-4">
                        <label className="form-label fw-semibold">Quick Search</label>
                        <div className="input-group">
                          <input type="text" className="form-control" placeholder="Search by name, mobile, ID, city, state..." />
                          <button className="btn btn-primary" type="button">Search</button>
                        </div>
                      </div>
                      <div className="row g-3">
                        <div className="col-md-6"><label className="form-label">📍 State</label><select className="form-select"><option value="">All States</option></select></div>
                        <div className="col-md-6"><label className="form-label">🏙️ City</label><select className="form-select"><option value="">All Cities</option></select></div>
                        <div className="col-md-6"><label className="form-label">📊 Status</label>
                          <select className="form-select">
                            <option value="">All Status</option>
                            <option value="approved">Approved</option>
                            <option value="pending">Pending</option>
                            <option value="rejected">Rejected</option>
                            <option value="hold">On Hold</option>
                          </select>
                        </div>
                        <div className="col-md-6"><label className="form-label">📅 Date From</label><input type="date" className="form-control" /></div>
                        <div className="col-md-6"><label className="form-label">📅 Date To</label><input type="date" className="form-control" /></div>
                        <div className="col-md-6"><label className="form-label">👥 Family Size</label>
                          <select className="form-select">
                            <option value="">Any Size</option>
                            <option value="1-2">1-2 Members</option>
                            <option value="3-5">3-5 Members</option>
                            <option value="6+">6+ Members</option>
                          </select>
                        </div>
                      </div>
                      <div className="mt-4">
                        <button className="btn btn-primary me-2">🔍 Search</button>
                        <button className="btn btn-outline-secondary me-2">🔄 Reset</button>
                        <button className="btn btn-success">📥 Export</button>
                      </div>
                    </div></div>
                  </div>
                  <div className="col-lg-4">
                    <div className="card border-0 bg-light h-100"><div className="card-body">
                      <h6 className="text-dark fw-bold mb-4">⚡ Quick Actions</h6>
                      <div className="d-grid gap-2">
                        <button className="btn btn-outline-primary btn-sm" onClick={() => { navigate('/Registrationdata'); setShowAdvancedSearch(false); }}>👥 All Registrations</button>
                        <button className="btn btn-outline-success btn-sm" onClick={() => { navigate('/approved-registrations'); setShowAdvancedSearch(false); }}>✅ Approved</button>
                        <button className="btn btn-outline-warning btn-sm" onClick={() => { navigate('/pending-approvals'); setShowAdvancedSearch(false); }}>⏳ Pending</button>
                        <button className="btn btn-outline-danger btn-sm" onClick={() => { navigate('/rejected-registrations'); setShowAdvancedSearch(false); }}>❌ Rejected</button>
                        <button className="btn btn-outline-info btn-sm" onClick={() => { navigate('/requests'); setShowAdvancedSearch(false); }}>⚠ Request Changes</button>
                        <button className="btn btn-outline-secondary btn-sm" onClick={() => { navigate('/Adminpass'); setShowAdvancedSearch(false); }}>🔐 Admin Users</button>
                      </div>
                    </div></div>
                  </div>
                </div>
              </div>
              <div className="modal-footer border-0">
                <button type="button" className="btn btn-secondary" onClick={() => setShowAdvancedSearch(false)}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Preferences Modal */}
      {showPreferences && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}>
          <div className="modal-dialog modal-xl">
            <div className="modal-content border-0 shadow-lg">
              <div className="modal-header" style={{ background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)' }}>
                <h5 className="modal-title text-white fw-bold">🔧 Preferences & Settings</h5>
                <button type="button" className="btn-close btn-close-white" onClick={() => setShowPreferences(false)}></button>
              </div>
              <div className="modal-body p-4">
                <div className="row g-4">
                  <div className="col-lg-6">
                    <div className="card border-0 h-100" style={{ background: 'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)' }}><div className="card-body">
                      <h6 className="text-white fw-bold mb-3">🎨 Theme Settings</h6>
                      <div className="mb-3"><label className="form-label text-white">Color Scheme</label>
                        <select className="form-select"><option>Default Teal</option><option>Dark Mode</option><option>Purple Theme</option></select>
                      </div>
                      <div className="mb-3"><label className="form-label text-white">Font Size</label>
                        <select className="form-select"><option>Small</option><option defaultValue>Medium</option><option>Large</option></select>
                      </div>
                      <div className="form-check">
                        <input className="form-check-input" type="checkbox" id="animations" defaultChecked />
                        <label className="form-check-label text-white" htmlFor="animations">Enable Animations</label>
                      </div>
                    </div></div>
                  </div>
                  <div className="col-lg-6">
                    <div className="card border-0 h-100" style={{ background: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)' }}><div className="card-body">
                      <h6 className="text-dark fw-bold mb-3">🔔 Notification Settings</h6>
                      {['Email Notifications', 'Push Notifications', 'Sound Notifications'].map(label => (
                        <div className="form-check mb-2" key={label}>
                          <input className="form-check-input" type="checkbox" defaultChecked />
                          <label className="form-check-label text-dark">{label}</label>
                        </div>
                      ))}
                    </div></div>
                  </div>
                  <div className="col-lg-6">
                    <div className="card border-0 h-100" style={{ background: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)' }}><div className="card-body">
                      <h6 className="text-dark fw-bold mb-3">📊 Dashboard Settings</h6>
                      <div className="mb-3"><label className="form-label text-dark">Default View</label>
                        <select className="form-select"><option>Statistics View</option><option>Table View</option><option>Card View</option></select>
                      </div>
                      <div className="mb-3"><label className="form-label text-dark">Refresh Interval</label>
                        <select className="form-select"><option>10 seconds</option><option defaultValue>30 seconds</option><option>1 minute</option></select>
                      </div>
                      <div className="form-check">
                        <input className="form-check-input" type="checkbox" id="autoRefresh" defaultChecked />
                        <label className="form-check-label text-dark" htmlFor="autoRefresh">Auto Refresh Data</label>
                      </div>
                    </div></div>
                  </div>
                  <div className="col-lg-6">
                    <div className="card border-0 h-100" style={{ background: 'linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%)' }}><div className="card-body">
                      <h6 className="text-dark fw-bold mb-3">🔐 Security Settings</h6>
                      <div className="mb-3"><label className="form-label text-dark">Session Timeout</label>
                        <select className="form-select"><option>15 minutes</option><option defaultValue>30 minutes</option><option>1 hour</option></select>
                      </div>
                      {['Two-Factor Authentication', 'Login Alerts', 'Auto Logout on Inactivity'].map(label => (
                        <div className="form-check mb-2" key={label}>
                          <input className="form-check-input" type="checkbox" defaultChecked />
                          <label className="form-check-label text-dark">{label}</label>
                        </div>
                      ))}
                    </div></div>
                  </div>
                </div>
              </div>
              <div className="modal-footer border-0">
                <button type="button" className="btn btn-success me-2">💾 Save Changes</button>
                <button type="button" className="btn btn-secondary" onClick={() => setShowPreferences(false)}>Cancel</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Enhanced Styles */}
      <style>{`
        .navbar-scrolled {
          backdrop-filter: blur(25px) !important;
          box-shadow: 0 8px 32px rgba(0,0,0,0.1) !important;
        }
        
        .nav-link-enhanced:hover {
          background: rgba(255,255,255,0.2) !important;
          transform: translateY(-2px);
          color: #ffd700 !important;
          box-shadow: 0 4px 15px rgba(255,215,0,0.3);
        }
        
        .brand-text {
          background: linear-gradient(45deg, #fff, #ffd700, #fff);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          animation: shimmer 3s ease-in-out infinite;
        }
        
        @keyframes shimmer {
          0%, 100% { background-position: -200% center; }
          50% { background-position: 200% center; }
        }
        
        .dropdown-enhanced {
          border-radius: 16px !important;
          backdrop-filter: blur(20px);
          background: rgba(255,255,255,0.95) !important;
          border: 1px solid rgba(255,255,255,0.2) !important;
          box-shadow: 0 20px 40px rgba(0,0,0,0.15) !important;
          animation: dropdownSlide 0.3s ease-out;
        }
        
        @keyframes dropdownSlide {
          from { opacity: 0; transform: translateY(-10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        .dropdown-item {
          border-radius: 8px;
          margin: 2px 8px;
          transition: all 0.2s ease;
        }
        
        .dropdown-item:hover {
          background: linear-gradient(135deg, #0D9488 0%, #0B7A6F 100%) !important;
          color: white !important;
          transform: translateX(5px);
        }
        
        .avatar-container {
          width: 35px;
          height: 35px;
          border-radius: 50%;
          background: linear-gradient(135deg, #0D9488 0%, #0B7A6F 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 15px rgba(13, 148, 136, 0.3);
        }
        
        .avatar {
          font-size: 1.2rem;
        }
        
        .avatar-large {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background: linear-gradient(135deg, #0D9488 0%, #0B7A6F 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
          color: white;
          margin: 0 auto;
        }
        
        .notification-badge {
          position: absolute;
          top: -5px;
          right: -5px;
          font-size: 0.7rem;
          min-width: 18px;
          height: 18px;
          border-radius: 50%;
        }
        
        .notification-dropdown {
          width: 300px;
          max-height: 400px;
          overflow-y: auto;
        }
        
        .notification-item {
          border-bottom: 1px solid rgba(0,0,0,0.05);
        }
        
        .notification-item:last-child {
          border-bottom: none;
        }
        
        .notification-icon {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.8rem;
          color: white;
        }
        
        .profile-dropdown {
          width: 250px;
        }
        
        .stat-item {
          padding: 5px 15px;
          background: rgba(255,255,255,0.7);
          border-radius: 20px;
          font-size: 0.9rem;
          backdrop-filter: blur(10px);
        }
        
        .stats-bar {
          animation: statsGlow 4s ease-in-out infinite alternate;
        }
        
        @keyframes statsGlow {
          0% { box-shadow: 0 4px 15px rgba(13, 148, 136, 0.15); }
          100% { box-shadow: 0 8px 30px rgba(13, 148, 136, 0.25); }
        }
        
        @media (max-width: 768px) {
          .navbar-brand {
            font-size: 1.2rem !important;
          }
          .brand-text {
            display: none;
          }
          .nav-link-enhanced {
            margin: 2px 0;
            text-align: center;
          }
          .stats-bar .d-flex {
            flex-direction: column;
            gap: 10px !important;
          }
          .stat-item {
            font-size: 0.8rem;
          }
        }
      `}</style>
    </>
  );
};

export default AHeader;